const setCookie = (name, value, days = 30) => {
  const maxAge = days * 24 * 60 * 60;
  // Remove 'secure' flag when accessing via IP address (for local network testing)
  const isLocalNetwork =
    window.location.hostname.match(/^\d+\.\d+\.\d+\.\d+$/) ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  const secureFlag = isLocalNetwork ? '' : 'secure;';
  document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; ${secureFlag} samesite=lax`;
};

const getCookie = (cookieName) => {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(cookieName + '='));
  return cookie ? cookie.substring(cookieName.length + 1) : null;
};

const removeCookie = (cookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export { setCookie, getCookie, removeCookie };
